module.exports = __webpack_public_path__ + "static/media/doggledoo.68334ffd.jpg";